<template>
  <div class="service-container" :style="{paddingTop: statusBarHeight + 'px'}">
    <div style="padding-top: 3vw;">
      <img v-if="currentPosition > 90" class="heartbeat" style="position: fixed;left: 50%;margin-left: -6vh;width: 12vh;z-index: 111111;" src="@/assets/serviceImg/yjjy.png"  @click="actionCallHelp()" />
      <div class="smoke-prize">
        <img style="width: 100%;margin: 0 auto;margin-top:3vw" src="@/assets/serviceImg/Onekey.png" @click="actionCallHelp()"  />
        <div class="text">24小时人工在线，一键救援，精准定位</div>
      </div>
      <div style="height:8vh">
        <div style="margin: 5vw 5vw 0vw 6vw;display: flex;align-items: center;float: left;">
      <div class="tit"></div>
        <span class="titspan">健康服务</span>
      </div>
      </div>

      <div style="padding-bottom: 5vh;">
        <div style="display: flex;align-items: center;width: 91.91vw;height: 25.5vw;">
          <div class="outpatientservice" @click="assist();flag(1)">
            <div class="ContentTitle">门诊协助</div>
            <div style="font-size: 3.5vw;color:#999999">快速精准预约 </div>
            <div style="font-size: 3.5vw;color:#999999">三甲医院科室</div>
          </div>
          <div class="Consultation" @click="doctor();flag(1)">
            <div class="ContentTitle">医学电话咨询</div>
            <div style="font-size: 3.5vw;color:#999999">专职医生电话</div>
            <div style="font-size: 3.5vw;color:#999999">远程问诊</div>
          </div>

        </div>
        <div style="display: flex;align-items: center;width: 91.91vw;height: 25.5vw;margin-top:2vw">
          <div class="gysc" @click="jd();flag(1)">
            <div class="ContentTitle">购药商城</div>
            <div style="font-size: 3.5vw;color:#999999">在线商城，放心  </div>
            <div style="font-size: 3.5vw;color:#999999">便捷购药</div>
          </div>
          <div class="jkzx" @click="actionOnlineAiDoctor();flag(1)">
            <div class="ContentTitle">健康咨询</div>
            <div style="font-size: 3.5vw;color:#999999">日常健康小问题  </div>
            <div style="font-size: 3.5vw;color:#999999">轻松解决</div>
          </div>

        </div>

        <div class="smoke-prize" style="border-radius: 40px;padding: 2vh 0vh;padding-left: 2vh;display: flex;align-items: center;margin-top: 2vh;" @click="screen();flag(1)">
          <img style="width: 5vh;" src="@/assets/serviceImg/jkcyc.png" />
          <div style="margin-left:1vw">
            <div class="ContentTitle">健康查一查</div>
            <div style="font-size: 3vw;color:#999999">常见疾病查一查，了解病因与治疗方法</div>
          </div>
          <img style="width: 2vh;" src="@/assets/serviceImg/sjb.png" />
          <!-- <div style="background: #ffffff;border-width: 2vh;border-style: solid;border-color: transparent transparent transparent #D1D1D1;"></div> -->
        </div>

        <div class="smoke-prize" style="padding: 2vh 0vh;display: flex;align-items: center;margin-top: 2vh;">
          <img style="width: 5.3vh;" src="@/assets/serviceImg/jtgh.png" />
          <div style="margin-left:1vw">
            <div class="ContentTitle" style="font-size:4.2vw;line-height: 4vh;">安心家庭</div>
            <div style="font-size: 3vw;color:#999999">
              <div>关爱家人，穿戴设备可捆绑多个</div>
              <div>账号，随时提醒随时关注~</div>
            </div>
          </div>
          <div style="background: #00BB82;border-radius: 16px;color:#ffffff;padding: 1.5vw 3vw;font-size: 3vw;" @click="sharing();flag(1)">去设置</div>
        </div>

        <div class="smoke-prize" style="padding: 2vh 0vh;display: flex;align-items: center;margin-top: 2vh;">
          <img style="width: 5.3vh;" src="@/assets/serviceImg/tjfx.png" />
          <div style="margin-left:1vw">
            <div class="ContentTitle" style="font-size:4.2vw;line-height: 4vh;">AI体检报告解读</div>
            <div style="font-size: 3vw;color:#999999">
              <div>AI解读报告，智能分析深度分析，</div>
              <div>清楚知晓体检结果</div>
            </div>
          </div>
          <div style="background: #00BB82;border-radius: 16px;color:#ffffff;padding: 1.5vw 3vw;font-size: 3vw;" @click="actionMedicalReport();flag(1)">去设置</div>
        </div>

        <div style="height:13vw;margin-top: 2vh;">
          <div style="margin: 3vw 5vw;display: flex;align-items: center;float: left;">
          <div class="tit"></div>
          <span class="titspan">出行救援服务</span>
          <!-- <img style="width: 3vh;" src="@/assets/serviceImg/wh.png" /> -->
          </div>
        </div>
        <div class="smoke-prize" style="padding: 2vh 0vh;">

            <div style="display: flex;align-items: center;">
            <div style="text-align: center;font-size: 3.6vw;width:30vw" @click="urgent();flag(2)">
              <img style="width: 7.5vh;" src="@/assets/serviceImg/jjylzy.png" />
              <div style="margin-top:2vw">紧急医疗转运</div>
            </div>
            <div style="text-align: center;font-size: 3.6vw;width:30vw" @click="medicalReturn();flag(2)">
              <img style="width: 7.5vh;" src="@/assets/serviceImg/ylsf.png" />
              <div style="margin-top:2vw">医疗送返</div>
            </div>
            <div style="text-align: center;font-size: 3.6vw;width:30vw" @click="admission();flag(2)">
              <img style="width: 7.5vh;" src="@/assets/serviceImg/rydb.png" />
              <div style="margin-top:2vw">入院担保</div>
            </div>
          </div>

          <div style="display: flex;align-items: center;margin-top:3vh" >
            <div style="text-align: center;font-size: 3.6vw;width:30vw" @click="medicalGuardianship();flag(2)">
              <img style="width: 7.5vh;" src="@/assets/serviceImg/yljh.png" />
              <div style="margin-top:2vw">医疗监护</div>
            </div>
            <div style="text-align: center;font-size: 3.6vw;width:30vw" @click="butlerservice();flag(2)">
              <img style="width: 7.5vh;" src="@/assets/serviceImg/aqgjfw.png" />
              <div style="margin-top:2vw">安全管家服务</div>
            </div>
            <div style="text-align: center;font-size: 3.6vw;width:30vw">

            </div>
          </div>
        </div>

        <div style="height:13vw;margin-top: 2vh;">
          <div style="margin: 3vw 5vw;display: flex;align-items: center;float: left;">
          <div class="tit"></div>
          <span class="titspan">社区服务</span>
          <!-- <img style="width: 3vh;" src="@/assets/serviceImg/wh.png" /> -->
          </div>
        </div>
        <div class="smoke-prize" style="padding: 2vh 0vh;">

            <div style="display: flex;align-items: center;">
            <div style="text-align: center;font-size: 3.6vw;width:30vw" @click="toilet();flag(2)">
              <img style="width: 7.5vh;" src="@/assets/serviceImg/stmtfw.png" />
              <div style="margin-top:2vw">疏通马桶服务</div>
            </div>
            <div style="text-align: center;font-size: 3.6vw;width:30vw" @click="unlocking();flag(2)">
              <img style="width: 7.5vh;" src="@/assets/serviceImg/jjksfw.png" />
              <div style="margin-top:2vw">紧急开锁服务</div>
            </div>
            <div style="text-align: center;font-size: 3.6vw;width:30vw" @click="service1();flag(2)">
              <img style="width: 7.5vh;" src="@/assets/serviceImg/jdwx.png" />
              <div style="margin-top:2vw">家电维修/清洗</div>
            </div>
          </div>


        </div>
        <div style="height:13vw;margin-top: 2vh;">
          <div style="margin: 3vw 5vw;display: flex;align-items: center;float: left;">
          <div class="tit"></div>
          <span class="titspan">健康知识</span>
          <!-- <img style="width: 3vh;" src="@/assets/serviceImg/wh.png" /> -->
          </div>
        </div>
        <div class="smoke-prize" style="padding: 3vw 4vw;position: relative;height: 28vw;margin-top:10px"  v-for="(item, index) in list"
            :key="index" @click="urlClick(item)">

            <img style="border-radius: 2vw;width: 28.5vw;height: 21.5vw;" :src="item.pic" />
          <div style="height: 28vw;border-radius: 3.38vw;width: 56vw;background: linear-gradient(137deg, rgb(255, 255, 255) 0%, rgb(231, 251, 252) 100%);position: absolute;right: 0px;top: 0px;" >
              <div class="ContentTitle" style="font-weight: normal;font-size:4.2vw;line-height: 6vw;margin-top: 3vw;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;">{{item.title}}</div>
              <div style="font-size: 3vw;color:#999999">
              <!-- <div style="overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;">请问肥胖和基因有关吗？一般情况下，容 易备份请问肥胖和基因有关吗？一般情况下，容 易备份请问肥胖和基因有关吗？一般情况下，容 易备份请问肥胖和基因有关吗？一般情况下，容 易备份</div> -->
            </div>
          </div>
          </div>
          <!-- <div class="smoke-prize" style="padding: 3vw 4vw;margin-top: 2vh;position: relative;height: 15vh;">

          <img style="width: 21.5vw;height: 21.5vw;" src="@/assets/serviceImg/tjfx.png" />
        <div style="height: 15vh;border-radius: 3.38vw;width: 63vw;background: linear-gradient(137deg, rgb(255, 255, 255) 0%, rgb(231, 251, 252) 100%);position: absolute;right: 0px;top: 0px;" >
            <div class="ContentTitle" style="font-size:4.2vw;line-height: 6vh;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;">请问脂肪肝倾向，什么意思？</div>
            <div style="font-size: 3vw;color:#999999">
            <div style="overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;">请问肥胖和基因有关吗？一般情况下，容 易备份请问肥胖和基因有关吗？一般情况下，容 易备份请问肥胖和基因有关吗？一般情况下，容 易备份请问肥胖和基因有关吗？一般情况下，容 易备份</div>
          </div>
        </div>
        </div>
        <div class="smoke-prize" style="padding: 3vw 4vw;margin-top: 2vh;position: relative;height: 15vh;">

          <img style="width: 21.5vw;height: 21.5vw;" src="@/assets/serviceImg/tjfx.png" />
        <div style="height: 15vh;border-radius: 3.38vw;width: 63vw;background: linear-gradient(137deg, rgb(255, 255, 255) 0%, rgb(231, 251, 252) 100%);position: absolute;right: 0px;top: 0px;" >
            <div class="ContentTitle" style="font-size:4.2vw;line-height: 6vh;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;">请问脂肪肝倾向，什么意思？</div>
            <div style="font-size: 3vw;color:#999999">
            <div style="overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;">请问肥胖和基因有关吗？一般情况下，容 易备份请问肥胖和基因有关吗？一般情况下，容 易备份请问肥胖和基因有关吗？一般情况下，容 易备份请问肥胖和基因有关吗？一般情况下，容 易备份</div>
          </div>
        </div>
        </div> -->
      </div>
      <div v-if="showModal" class="modal">
        <div class="modal-content">
          <span class="close" @click="showModal = false">&times;</span>
          <p style="margin-bottom: 7vw;">该项权益需开通以下服务权益</p>
          <div style="width:100%;height:40vw;position: relative;" @click="equity()">
            <img style="width: 100%;height: 100%;position: absolute;top: 2vw;" src="@/assets/img/qykbj.png" />
            <div>
              <h3 style="position: absolute;top: 17vw;left: 7vw;font-size: 5vw;">大救星-星健康权益卡</h3>
              <div style="position: absolute;top: 25vw;left: 7vw;color:#666666;font-size: 3.5vw;">多项健康权益尊享，为您健康守护</div>
              <div style="width: 18vw;height: 7vw;font-size: 3vw;line-height: 7vw;color: #F2D57A;text-align: center;background: rgb(74, 71, 64);border-radius: 16px;position: absolute;top: 17vw;right: 4vw;">了解更多</div>
            </div>
          </div>
        </div>

      </div>
      <!-- tabbar菜单 -->
      <Tabbar />
    </div>
  </div>
</template>

<script>
// util
import { mapState } from 'pinia';
import { useGlobalStore } from '@/stores/global';
// service
import { skipstore,appnews,equityinfo,flag } from '@/api/activity'

export default {
  components: {
    Tabbar: () => import("@/components/Tabbar")
  },
  data() {
    return {
      currentPosition: 0,
      list:[],
      showModal: false,
      equityinfoType:false,
    };
  },
  computed: {
    ...mapState(useGlobalStore, ['statusBarHeight'])
	},
  mounted() {
    if (this.$env.inAndroid){
               try {
                JSInterface.loadNewUrl(window.location.href)
              } catch (error) {
                console.log(error)
              }
            }
   this.init()
   this.appnews()
   window.addEventListener('scroll', this.updateCurrentPosition);
  },

  beforeCreate() {
    window.removeEventListener('scroll', this.updateCurrentPosition);
    document.title = "服务"
    document
      .querySelector("#app")
      .setAttribute("style", "background-color:#F2F3F5");
  },
  methods: {
    async init() {
      let data = {}
      let res = await equityinfo(data)
      if (res.code == '1000') {
        this.equityinfoType = res.data
      localStorage.setItem('equityinfo', res.data);
      }
    },
    async appnews() {
      let data = {}
      let res = await appnews(data)
      if (res.code == '1000') {
        this.list = res.data
      }
    },
    async flag(item) {
      let res = await flag(item)
      if (res.code == '1000') {
        // this.list = res.data
      }
    },
    urlClick(item) {
      window.location.href =
        'appdjxhealth://actionOpenh5?url='   + encodeURIComponent(item.url)
    },
    actionOnlineAiDoctor() {
      if(this.equityinfoType == false) {
        this.showModal = true;
      }else {
        window.location.href =
        'appdjxhealth://actionOnlineAiDoctor'
      }

    },
    actionMedicalReport() {
      if(this.equityinfoType == false) {
        this.showModal = true;
      }else {
      window.location.href =
        'appdjxhealth://actionMedicalReport'
      }
    },
    actionCallHelp() {
      this.$router.push({
            name: 'onClickRescue',
            query: {}
        });
      // window.location.href =
      //   'appdjxhealth://actionCallHelp'
    },
    jd() {
      skipstore().then((res)=> {
        window.location.href =
        'appdjxhealth://actionOpenh5?url=' + encodeURIComponent(res.data)
        // window.location.href = res.data
        console.log(res)
      })
    },
    equity() {
      window.location.href =
        'appdjxhealth://actionOpenh5?url='   + encodeURIComponent('http://health.dajiuxing.com.cn/h5/#/equity')
    },
    sharing() {
      // if(this.equityinfoType == false) {
      //   this.showModal = true;
      // }else {
       window.location.href =
        'appdjxhealth://actionOpenh5?url='   + encodeURIComponent('http://health.dajiuxing.com.cn/h5/#/sharing')
      // this.$router.push({
      //         path: "/sharing",
      //         query:{
      //         }
      //       });
      // }

    },
    assist() {
      window.location.href =
        'appdjxhealth://actionOpenh5?url='   + encodeURIComponent('http://health.dajiuxing.com.cn/h5/#/assist')
      // this.$router.push({
      //         path: "/assist",
      //         query:{
      //         }
      //       });
    },
    urgent() {
      window.location.href =
        'appdjxhealth://actionOpenh5?url='  + encodeURIComponent('http://health.dajiuxing.com.cn/h5/#/urgent')
      // this.$router.push({
      //         path: "/urgent",
      //         query:{
      //         }
      //       });
    },
    toilet() {
      window.location.href =
        'appdjxhealth://actionOpenh5?url='  + encodeURIComponent('http://health.dajiuxing.com.cn/h5/#/toilet')
      // this.$router.push({
      //         path: "/toilet",
      //         query:{
      //         }
      //       });
    },
    unlocking() {
      window.location.href =
        'appdjxhealth://actionOpenh5?url=' + encodeURIComponent('http://health.dajiuxing.com.cn/h5/#/unlocking')
      // this.$router.push({
      //         path: "/unlocking",
      //         query:{
      //         }
      //       });
    },
    service1() {
      window.location.href =
        'appdjxhealth://actionOpenh5?url='  + encodeURIComponent('http://health.dajiuxing.com.cn/h5/#/service1')
      // this.$router.push({
      //         path: "/service1",
      //         query:{
      //         }
      //       });
    },
    butlerservice() {
      window.location.href =
        'appdjxhealth://actionOpenh5?url=' + encodeURIComponent('http://health.dajiuxing.com.cn/h5/#/butlerservice')
      // this.$router.push({
      //         path: "/butlerservice",
      //         query:{
      //         }
      //       });
    },
    medicalReturn() {
      window.location.href =
        'appdjxhealth://actionOpenh5?url='    + encodeURIComponent('http://health.dajiuxing.com.cn/h5/#/medicalReturn')
      // this.$router.push({
      //         path: "/medicalReturn",
      //         query:{
      //         }
      //       });
    },
    medicalGuardianship() {
      window.location.href =
        'appdjxhealth://actionOpenh5?url=' + encodeURIComponent('http://health.dajiuxing.com.cn/h5/#/medicalGuardianship')
      // this.$router.push({
      //         path: "/medicalGuardianship",
      //         query:{
      //         }
      //       });

    },
    doctor() {
      window.location.href =
        'appdjxhealth://actionOpenh5?url=' + encodeURIComponent('http://health.dajiuxing.com.cn/h5/#/doctor')

      // this.$router.push({
      //         path: "/doctor",
      //         query:{
      //         }
      //       });
    },
    admission() {
      window.location.href =
        'appdjxhealth://actionOpenh5?url=' + encodeURIComponent('http://health.dajiuxing.com.cn/h5/#/admission')
      // this.$router.push({
      //         path: "/admission",
      //         query:{
      //         }
      //       });
    },
    screen() {

      if(this.equityinfoType == false) {
        this.showModal = true;
      }else {
           window.location.href =
        'appdjxhealth://actionOpenh5?url=' + encodeURIComponent('http://health.dajiuxing.com.cn/h5/#/screen')
        // this.$router.push({
        //       path: "/screen",
        //       query:{
        //       }
        //     });
      }

    },

    updateCurrentPosition() {
      this.currentPosition = window.scrollY;
    },
  },
};
</script>
<style scoped>
.service-container {
  min-height: 100vh;
  background-color:#F2F3F5;
}
* {
  margin: 0 auto;
  padding: 0;
  font-family: "微软雅黑";
}
.modal {

  position: fixed;
  z-index: 1000000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0,0,0);
  background-color: rgba(0,0,0,0.4);
}
.modal-content {
  background-color: #fefefe;
  padding: 8% 5%;
  border-radius: 12px 12px 0px 0px;
  position: absolute;
  bottom: 0;
  width: 100%;
  line-height: 0;
}
.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}
.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}
.heartbeat {
    bottom: 75px;
    animation: heartbeat 1s infinite;
  }

  @keyframes heartbeat {
    0% {
      transform: scale(1);
      opacity: 1;
    }
    50% {
      transform: scale(1.1);
      opacity: 0.8;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }
.ContentTitle {
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 4vw;

  color: #333333;
  line-height: 5vh;
  text-align: justify;
  font-style: normal;
}
.Consultation {
  width: 44vw;
    height: 25.55vw;
    padding: 3vw;
  background: url('~@/assets/serviceImg/Consultation.png') center no-repeat;
  background-size: 100%;
}
.jkzx {
  width: 44vw;
    height: 25.55vw;
    padding: 3vw;
  background: url('~@/assets/serviceImg/jkzx.png') center no-repeat;
  background-size: 100%;
}
.gysc {
  width: 44vw;
    height: 25.55vw;
    padding: 3vw;
  background: url('~@/assets/serviceImg/gysc.png') center no-repeat;
  background-size: 100%;
}

.outpatientservice {
  width: 44vw;
    height: 25.55vw;
  background: url('~@/assets/serviceImg/outpatientservice.png') center no-repeat;
  background-size: 100%;
  padding: 3vw;
}
.smoke-prize {
  width: 91.91vw;
  /* height: 10vh; */
  background: #ffffff;
  border-radius: 3.38vw;
  /* margin: -10.5vh auto 1.5vh; */
  padding: 2.55vh 12.25vw;
}
.text {
font-family: PingFangSC, PingFang SC;
font-weight: 400;
font-size: 3.5vw;
color: #00C275;
/* line-height: 7vh; */
margin: 3.5vh 0;
text-align: center;
font-style: normal;
}
.tit {
  width: 1.5vw;
  height: 5vw;
  background-color: #009944;
  border: 1px solid #009944;
  border-radius: 3.38vw;
  display: inline-block;
}
.titspan {
  margin-left:2vw;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  /* font-size: 5vw; */
  font-size: 5vw;
  color: #333333;
  /* line-height: 22px; */
  text-align: justify;
  font-style: normal;
}
</style>



// WEBPACK FOOTER //
// src/views/service/index.vue